import Vue from "vue";
import VueRouter from "vue-router";
import layout from "../layout/index.vue";
Vue.use(VueRouter);
//
const routes = [
  {
    path: "/",
    component: layout,
    children: [
      {
        path: "/",
        name: "home",

        component: () => import("../views/index.vue"),
        meta: { title: "首页" },
      },
    ],
  },
  {
    path: "/login",
    component: layout,
    name: "登录",
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/updatePassWord",
    component: layout,
    name: "修改密码",
    component: () => import("../views/login/updatePassWord.vue"),
  },
  {
    path: "/register",
    component: layout,
    name: "注册账号",
    component: () => import("../views/login/register.vue"),
  },
  {
    path: "/test/testStart",
    component: layout,
    name: "开始答题",
    component: () => import("../views/test/testStart.vue"),
  },
  {
    path: "/test/worth",
    component: layout,
    name: "测试欢迎主页",
    component: () => import("../views/test/worth.vue"),
  },
  {
    path: "/test/worthtest",
    component: layout,
    name: "测试主页",
    component: () => import("../views/test/worthtest.vue"),
  },
  {
    path: "/test/testresult",
    component: layout,
    name: "测验结果",
    component: () => import("../views/test/testresult.vue"),
  },
  {
    path: "/capsule/capsule",
    component: layout,
    name: "情绪胶囊",
    component: () => import("../views/capsule/capsule.vue"),
  },
  {
    path: "/circle/circle",
    component: layout,
    name: "圈子",
    component: () => import("../views/circle/circle.vue"),
  },
  {
    path: "/evaluating/record",
    component: layout,
    name: "测评记录",
    component: () => import("../views/evaluating/record.vue"),
  },
  {
    path: "/medals/medal",
    component: layout,
    name: "勋章",
    component: () => import("../views/medals/medal.vue"),
  },
  {
    path: "/user/usermsg",
    component: layout,
    name: "个人信息",
    component: () => import("../views/user/usermsg.vue"),
  },
  {
    path: "/report/stage",
    component: layout,
    name: "阶段报告",
    component: () => import("../views/report/stage.vue"),
  },
  {
    path: "/practice/achievement",
    component: layout,
    name: "练习成果",
    component: () => import("../views/practice/achievement.vue"),
  },
  {
    path: "/practice/file",
    component: layout,
    name: "练习档案",
    component: () => import("../views/practice/file.vue"),
  },
  {
    path: "/practice/like",
    component: layout,
    name: "喜欢的练习",
    component: () => import("../views/practice/like.vue"),
  },
  {
    path: "/report/fillIn",
    component: layout,
    name: "填写勋章",
    component: () => import("../views/report/fillIn.vue"),
  },
  {
    path: "/setout/index",
    component: layout,
    name: "今日练习",
    component: () => import("../views/setout/index.vue"),
  },
  {
    path: "/setout/handbook",
    component: layout,
    name: "入营指南",
    component: () => import("../views/setout/handbook.vue"),
  },
  {
    path: "/setout/mepromise",
    component: layout,
    name: "对自己的承诺",
    component: () => import("../views/setout/mepromise.vue"),
  },
  {
    path: "/setout/signature",
    component: layout,
    name: "签署承诺书",
    component: () => import("../views/setout/signature.vue"),
  },
  {
    path: "/setout/ninjia",
    component: layout,
    name: "情绪小练习",
    component: () => import("../views/setout/ninjia.vue"),
  },
  {
    path: "/setout/ckninjia",
    component: layout,
    name: "查看小练习",
    component: () => import("../views/setout/ckninjia.vue"),
  },
  {
    path: "/setout/assistant",
    component: layout,
    name: "练习助手",
    component: () => import("../views/setout/assistant.vue"),
  },
  {
    path: "/emotion/diary",
    component: layout,
    name: "情绪日记",
    component: () => import("../views/emotion/diary.vue"),
  },
  {
    path: "/emotion/ckdiary",
    component: layout,
    name: "查看情绪日记",
    component: () => import("../views/emotion/ckdiary.vue"),
  },
  {
    path: "/setout/check",
    component: layout,
    name: "查看承诺书",
    component: () => import("../views/setout/check.vue"),
  },
  {
    path: "/emotion/SevenDay",
    component: layout,
    name: "7天情绪坐标",
    component: () => import("../views/emotion/SevenDay.vue"),
  },
  {
    path: "/setout/practicelist",
    component: layout,
    name: "练习列表",
    component: () => import("../views/setout/practicelist.vue"),
  },

  {
    path: "/setout/trainingground",
    component: layout,
    name: "情绪训练场",
    component: () => import("../views/setout/trainingground.vue"),
  },
  {
    path: "/setout/traininggroundItem",
    component: layout,
    name: "情景训练场选择",
    component: () => import("../views/setout/traininggroundItem.vue"),
  },
  {
    path: "/test",
    component: layout,
    name: "宝洁能量测评",
    component: () => import("../views/baojie/test.vue"),
  },
  {
    path: "/result",
    component: layout,
    name: "宝洁能量测评报告",
    component: () => import("../views/baojie/result.vue"),
  },
  {
    path: "/welcome",
    component: layout,
    name: "宝洁指导语",
    component: () => import("../views/baojie/welcome.vue"),
  },
  {
    path: "/testH",
    component: layout,
    name: "后测能量测评",
    component: () => import("../views/HouCe/test.vue"),
  },
  {
    path: "/resultH",
    component: layout,
    name: "后测能量测评报告",
    component: () => import("../views/HouCe/result.vue"),
  },
  {
    path: "/welcomeH",
    component: layout,
    name: "后测指导语",
    component: () => import("../views/HouCe/welcome.vue"),
  },
  {
    path: "/HouCe/comparison",
    component: layout,
    name: "后侧对比报告",
    component: () => import("../views/HouCe/comparison.vue"),
  },
  {
    path: "/CP/minsheng/login",
    component: layout,
    name: "测评登录",
    component: () => import("../CP/minsheng/login.vue"),
  },

  {
    path: "/CP/minsheng/password",
    component: layout,
    name: "修改密码",
    component: () => import("../CP/minsheng/password.vue"),
  },
  {
    path: "/CP/minsheng/answer",
    component: layout,
    name: "测评",
    component: () => import("../CP/minsheng/answer.vue"),
  },
  {
    path: "/CP/minsheng/guide",
    component: layout,
    name: "引导语",
    component: () => import("../CP/minsheng/guide.vue"),
  },
  {
    path: "/CP/minsheng/Report",
    component: layout,
    name: "报告结果",
    component: () => import("../CP/minsheng/Report.vue"),
  },
  {
    path: "/CP/minsheng/answerOver",
    component: layout,
    name: "查看报告",
    component: () => import("../CP/minsheng/answerOver.vue"),
  },
  // 英大
  {
    path: "/CP/yingda/login",
    component: layout,
    name: "英大测评登录",
    component: () => import("../CP/yingda/login.vue"),
  },
  {
    path: "/CP/yingda/answer",
    component: layout,
    name: "英大测评",
    component: () => import("../CP/yingda/answer.vue"),
  },
  {
    path: "/CP/yingda/guide",
    component: layout,
    name: "英大引导语",
    component: () => import("../CP/yingda/guide.vue"),
  },
  {
    path: "/CP/yingda/Report",
    component: layout,
    name: "英大报告结果",
    component: () => import("../CP/yingda/Report.vue"),
  },
  {
    path: "/CP/yingda/answerOver",
    component: layout,
    name: "英大查看报告",
    component: () => import("../CP/yingda/answerOver.vue"),
  }, // 大鹏
  {
    path: "/CP/dapeng/login",
    component: layout,
    name: "大鹏测评登录",
    component: () => import("../CP/dapeng/login.vue"),
  },
  {
    path: "/CP/dapeng/answer",
    component: layout,
    name: "大鹏测评",
    component: () => import("../CP/dapeng/answer.vue"),
  },
  {
    path: "/CP/dapeng/guide",
    component: layout,
    name: "大鹏引导语",
    component: () => import("../CP/dapeng/guide.vue"),
  },
  {
    path: "/CP/dapeng/Report",
    component: layout,
    name: "大鹏报告结果",
    component: () => import("../CP/dapeng/Report.vue"),
  },
  {
    path: "/CP/dapeng/answerOver",
    component: layout,
    name: "大鹏查看报告",
    component: () => import("../CP/dapeng/answerOver.vue"),
  }, // 大鹏
  {
    path: "/CP/chat/login",
    component: layout,
    name: "对话测评登录",
    component: () => import("../CP/chat/login.vue"),
  },
  {
    path: "/CP/chat/answer",
    component: layout,
    name: "对话测评",
    component: () => import("../CP/chat/answer.vue"),
  },
  {
    path: "/CP/chat/list",
    component: layout,
    name: "对话测评列表",
    component: () => import("../CP/chat/list.vue"),
  },
  {
    path: "/CP/chat/guide",
    component: layout,
    name: "对话引导语",
    component: () => import("../CP/chat/guide.vue"),
  },
  {
    path: "/CP/chat/Report",
    component: layout,
    name: "对话报告结果",
    component: () => import("../CP/chat/Report.vue"),
  },
  {
    path: "/CP/chat/answerOver",
    component: layout,
    name: "对话查看报告",
    component: () => import("../CP/chat/answerOver.vue"),
  },
  {
    path: "/CP/chat/Reportlist",
    component: layout,
    name: "对话查看报告列表",
    component: () => import("../CP/chat/Reportlist.vue"),
  },
  // 华创
  {
    path: "/CP/huachuang/login",
    component: layout,
    name: "华创测评登录",
    component: () => import("../CP/huachuang/login.vue"),
  },
  {
    path: "/CP/huachuang/answer",
    component: layout,
    name: "华创测评",
    component: () => import("../CP/huachuang/answer.vue"),
  },
  {
    path: "/CP/huachuang/guide",
    component: layout,
    name: "华创引导语",
    component: () => import("../CP/huachuang/guide.vue"),
  },
  {
    path: "/CP/huachuang/Report",
    component: layout,
    name: "华创报告结果",
    component: () => import("../CP/huachuang/Report.vue"),
  },
  {
    path: "/CP/huachuang/answerOver",
    component: layout,
    name: "华创查看报告",
    component: () => import("../CP/huachuang/answerOver.vue"),
  },
  {
    path: "/CP/huachuang/password",
    component: layout,
    name: "密码修改",
    component: () => import("../CP/huachuang/password.vue"),
  }, // huawei
  {
    path: "/CP/huawei/login",
    component: layout,
    name: "华为测评登录",
    component: () => import("../CP/huawei/login.vue"),
  },
  {
    path: "/CP/huawei/answer",
    component: layout,
    name: "华为测评",
    component: () => import("../CP/huawei/answer.vue"),
  },
  {
    path: "/CP/huawei/guide",
    component: layout,
    name: "华为引导语",
    component: () => import("../CP/huawei/guide.vue"),
  },
  {
    path: "/CP/huawei/Report",
    component: layout,
    name: "华为报告结果",
    component: () => import("../CP/huawei/Report.vue"),
  },
  {
    path: "/CP/huawei/answerOver",
    component: layout,
    name: "华为查看报告",
    component: () => import("../CP/huawei/answerOver.vue"),
  },
  {
    path: "/CP/huawei/TCReport",
    component: layout,
    name: "老师端报告结果",
    component: () => import("../CP/huawei/TCReport.vue"),
  },
  {
    path: "/CP/huawei/TClist",
    component: layout,
    name: "老师端报告结果",
    component: () => import("../CP/huawei/TClist.vue"),
  },
  {
    path: "/CP/huawei/list",
    component: layout,
    name: "历史报告",
    component: () => import("../CP/huawei/list.vue"),
  },
  // xinlijiankang
  {
    path: "/CP/xinlijiankang/login",
    component: layout,
    name: "健康素养测评登录",
    component: () => import("../CP/xinlijiankang/login.vue"),
  },
  {
    path: "/CP/xinlijiankang/answer",
    component: layout,
    name: "健康素养测评",
    component: () => import("../CP/xinlijiankang/answer.vue"),
  },
  {
    path: "/CP/xinlijiankang/guide",
    component: layout,
    name: "健康素养引导语",
    component: () => import("../CP/xinlijiankang/guide.vue"),
  },
  {
    path: "/CP/xinlijiankang/Report",
    component: layout,
    name: "健康素养报告结果",
    component: () => import("../CP/xinlijiankang/Report.vue"),
  },
  {
    path: "/CP/xinlijiankang/answerOver",
    component: layout,
    name: "健康素养查看报告",
    component: () => import("../CP/xinlijiankang/answerOver.vue"),
  },

  // 卓越
  {
    path: "/CP/zhuoyue/login",
    component: layout,
    name: "卓越测评登录",
    component: () => import("../CP/zhuoyue/login.vue"),
  },

  {
    path: "/CP/zhuoyue/password",
    component: layout,
    name: "卓越修改密码",
    component: () => import("../CP/zhuoyue/password.vue"),
  },
  {
    path: "/CP/zhuoyue/answer",
    component: layout,
    name: "卓越测评",
    component: () => import("../CP/zhuoyue/answer.vue"),
  },
  {
    path: "/CP/zhuoyue/guide",
    component: layout,
    name: "卓越引导语",
    component: () => import("../CP/zhuoyue/guide.vue"),
  },
  {
    path: "/CP/zhuoyue/Report",
    component: layout,
    name: "卓越报告结果",
    component: () => import("../CP/zhuoyue/Report.vue"),
  },
  {
    path: "/CP/zhuoyue/answerOver",
    component: layout,
    name: "卓越查看报告",
    component: () => import("../CP/zhuoyue/answerOver.vue"),
  },
  {
    path: "/CP/zhuoyue/loginhou",
    component: layout,
    name: "卓越测评登录",
    component: () => import("../CP/zhuoyue/loginhou.vue"),
  },

  {
    path: "/CP/zhuoyue/answerhou",
    component: layout,
    name: "卓越测评后侧",
    component: () => import("../CP/zhuoyue/answerhou.vue"),
  },
  {
    path: "/CP/zhuoyue/guidehou",
    component: layout,
    name: "卓越引导语后侧",
    component: () => import("../CP/zhuoyue/guidehou.vue"),
  },
  {
    path: "/CP/zhuoyue/Reporthou",
    component: layout,
    name: "卓越报告结果后侧",
    component: () => import("../CP/zhuoyue/Reporthou.vue"),
  },
  {
    path: "/CP/zhuoyue/answerOverhou",
    component: layout,
    name: "卓越查看报告后侧",
    component: () => import("../CP/zhuoyue/answerOverhou.vue"),
  },
  // 臻鼎
  {
    path: "/CP/zhending/login",
    component: layout,
    name: "臻鼎测评登录后侧",
    component: () => import("../CP/zhending/login.vue"),
  },

  {
    path: "/CP/zhending/password",
    component: layout,
    name: "臻鼎修改密码",
    component: () => import("../CP/zhending/password.vue"),
  },
  {
    path: "/CP/zhending/answer",
    component: layout,
    name: "臻鼎测评",
    component: () => import("../CP/zhending/answer.vue"),
  },
  {
    path: "/CP/zhending/guide",
    component: layout,
    name: "臻鼎引导语",
    component: () => import("../CP/zhending/guide.vue"),
  },
  {
    path: "/CP/zhending/Report",
    component: layout,
    name: "臻鼎报告结果",
    component: () => import("../CP/zhending/Report.vue"),
  },
  {
    path: "/CP/zhending/answerOver",
    component: layout,
    name: "臻鼎查看报告",
    component: () => import("../CP/zhending/answerOver.vue"),
  },

  //西部钻探
  {
    path: "/CP/xibu/login",
    component: layout,
    name: "西部测评登录",
    component: () => import("../CP/xibu/login.vue"),
  },
  {
    path: "/CP/xibu/answer",
    component: layout,
    name: "西部测评",
    component: () => import("../CP/xibu/answer.vue"),
  },
  {
    path: "/CP/xibu/guide",
    component: layout,
    name: "西部引导语",
    component: () => import("../CP/xibu/guide.vue"),
  },
  {
    path: "/CP/xibu/Report",
    component: layout,
    name: "西部报告结果",
    component: () => import("../CP/xibu/Report.vue"),
  },
  {
    path: "/CP/xibu/answerOver",
    component: layout,
    name: "西部查看报告",
    component: () => import("../CP/xibu/answerOver.vue"),
  },

  // 益达
  {
    path: "/CP/yida/login",
    component: layout,
    name: "益达测评登录",
    component: () => import("../CP/yida/login.vue"),
  },
  {
    path: "/CP/yida/answer",
    component: layout,
    name: "益达测评",
    component: () => import("../CP/yida/answer.vue"),
  },
  {
    path: "/CP/yida/guide",
    component: layout,
    name: "益达引导语",
    component: () => import("../CP/yida/guide.vue"),
  },
  {
    path: "/CP/yida/Report",
    component: layout,
    name: "益达报告结果",
    component: () => import("../CP/yida/Report.vue"),
  },
  {
    path: "/CP/yida/answerOver",
    component: layout,
    name: "益达查看报告",
    component: () => import("../CP/yida/answerOver.vue"),
  }, // 众山
  {
    path: "/CP/zhongshan/login",
    component: layout,
    name: "众山测评登录",
    component: () => import("../CP/zhongshan/login.vue"),
  },
  {
    path: "/CP/zhongshan/answer",
    component: layout,
    name: "众山测评",
    component: () => import("../CP/zhongshan/answer.vue"),
  },
  {
    path: "/CP/zhongshan/guide",
    component: layout,
    name: "众山引导语",
    component: () => import("../CP/zhongshan/guide.vue"),
  },
  {
    path: "/CP/zhongshan/Report",
    component: layout,
    name: "众山报告结果",
    component: () => import("../CP/zhongshan/Report.vue"),
  },
  {
    path: "/CP/zhongshan/answerOver",
    component: layout,
    name: "众山查看报告",
    component: () => import("../CP/zhongshan/answerOver.vue"),
  }, // 众山
  {
    path: "/CP/gongdianju/login",
    component: layout,
    name: "深圳供电局测评登录",
    component: () => import("../CP/gongdianju/login.vue"),
  },
  {
    path: "/CP/gongdianju/answer",
    component: layout,
    name: "深圳供电局测评",
    component: () => import("../CP/gongdianju/answer.vue"),
  },
  {
    path: "/CP/gongdianju/guide",
    component: layout,
    name: "深圳供电局引导语",
    component: () => import("../CP/gongdianju/guide.vue"),
  },
  {
    path: "/CP/gongdianju/Report",
    component: layout,
    name: "深圳供电局报告结果",
    component: () => import("../CP/gongdianju/Report.vue"),
  },
  {
    path: "/CP/gongdianju/answerOver",
    component: layout,
    name: "深圳供电局查看报告",
    component: () => import("../CP/gongdianju/answerOver.vue"),
  }, // 东胜油田
  {
    path: "/CP/dongsheng/login",
    component: layout,
    name: "东胜油田测评登录",
    component: () => import("../CP/dongsheng/login.vue"),
  },
  {
    path: "/CP/dongsheng/answer",
    component: layout,
    name: "东胜油田测评",
    component: () => import("../CP/dongsheng/answer.vue"),
  },
  {
    path: "/CP/dongsheng/guide",
    component: layout,
    name: "东胜油田引导语",
    component: () => import("../CP/dongsheng/guide.vue"),
  },
  {
    path: "/CP/dongsheng/Report",
    component: layout,
    name: "东胜油田报告结果",
    component: () => import("../CP/dongsheng/Report.vue"),
  },
  {
    path: "/CP/dongsheng/answerOver",
    component: layout,
    name: "东胜油田查看报告",
    component: () => import("../CP/dongsheng/answerOver.vue"),
  },
  // 深圳供电局调解督导员测评登录
  {
    path: "/CP/gongdianju2/login",
    component: layout,
    name: "深圳供电局调解督导员测评登录",
    component: () => import("../CP/gongdianju2/login.vue"),
  },
  {
    path: "/CP/gongdianju2/answer",
    component: layout,
    name: "深圳供电局调解督导员测评",
    component: () => import("../CP/gongdianju2/answer.vue"),
  },
  {
    path: "/CP/gongdianju2/guide",
    component: layout,
    name: "深圳供电局调解督导员引导语",
    component: () => import("../CP/gongdianju2/guide.vue"),
  },
  {
    path: "/CP/gongdianju2/Report",
    component: layout,
    name: "深圳供电局调解督导员报告结果",
    component: () => import("../CP/gongdianju2/Report.vue"),
  },
  {
    path: "/CP/gongdianju2/answerOver",
    component: layout,
    name: "深圳供电局调解督导员查看报告",
    component: () => import("../CP/gongdianju2/answerOver.vue"),
  },
  {
    path: "/CP/minsheng2/login",
    component: layout,
    name: "测评登录",
    component: () => import("../CP/minsheng2/login.vue"),
  },
  {
    path: "/CP/minsheng2/password",
    component: layout,
    name: "修改密码",
    component: () => import("../CP/minsheng2/password.vue"),
  },
  {
    path: "/CP/minsheng2/answer",
    component: layout,
    name: "测评",
    component: () => import("../CP/minsheng2/answer.vue"),
  },
  {
    path: "/CP/minsheng2/guide",
    component: layout,
    name: "引导语",
    component: () => import("../CP/minsheng2/guide.vue"),
  },
  {
    path: "/CP/minsheng2/Report",
    component: layout,
    name: "报告结果",
    component: () => import("../CP/minsheng2/Report.vue"),
  },
  {
    path: "/CP/minsheng2/answerOver",
    component: layout,
    name: "查看报告",
    component: () => import("../CP/minsheng2/answerOver.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
